import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9369ceba"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "footer-index"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Home", -1));
const _hoisted_4 = ["onClick"];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Ranking", -1));
const _hoisted_6 = ["onClick"];
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Task", -1));
const _hoisted_8 = ["onClick"];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Refer", -1));
const _hoisted_10 = ["onClick"];
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Suprise", -1));
import { onMounted } from "vue";
export default {
  __name: 'index',
  setup(__props) {
    onMounted(() => {});
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("ul", null, [_createVNode(_component_router_link, {
        to: {
          name: 'home'
        }
      }, {
        default: _withCtx(({
          navigate,
          isActive
        }) => [_createElementVNode("li", {
          onClick: navigate,
          class: _normalizeClass({
            active: isActive
          })
        }, [_createVNode(_component_svg_icon, {
          "icon-class": "icon-home",
          class: "icon"
        }), _hoisted_3], 10, _hoisted_2)]),
        _: 1
      }), _createVNode(_component_router_link, {
        to: {
          name: 'ranking'
        }
      }, {
        default: _withCtx(({
          navigate,
          isActive
        }) => [_createElementVNode("li", {
          onClick: navigate,
          class: _normalizeClass({
            active: isActive
          })
        }, [_createVNode(_component_svg_icon, {
          "icon-class": "icon-ranking",
          class: "icon"
        }), _hoisted_5], 10, _hoisted_4)]),
        _: 1
      }), _createVNode(_component_router_link, {
        to: {
          name: 'task'
        }
      }, {
        default: _withCtx(({
          navigate,
          isActive
        }) => [_createElementVNode("li", {
          onClick: navigate,
          class: _normalizeClass({
            active: isActive
          })
        }, [_createVNode(_component_svg_icon, {
          "icon-class": "icon-task",
          class: "icon"
        }), _hoisted_7], 10, _hoisted_6)]),
        _: 1
      }), _createVNode(_component_router_link, {
        to: {
          name: 'refer'
        }
      }, {
        default: _withCtx(({
          navigate,
          isActive
        }) => [_createElementVNode("li", {
          onClick: navigate,
          class: _normalizeClass({
            active: isActive || _ctx.$route.meta.routeActive === 'refer'
          })
        }, [_createVNode(_component_svg_icon, {
          "icon-class": "icon-refer",
          class: "icon"
        }), _hoisted_9], 10, _hoisted_8)]),
        _: 1
      }), _createVNode(_component_router_link, {
        to: {
          name: 'suprise'
        }
      }, {
        default: _withCtx(({
          navigate,
          isActive
        }) => [_createElementVNode("li", {
          onClick: navigate,
          class: _normalizeClass({
            active: isActive
          })
        }, [_createVNode(_component_svg_icon, {
          "icon-class": "icon-suprise",
          class: "icon"
        }), _hoisted_11], 10, _hoisted_10)]),
        _: 1
      })])]);
    };
  }
};